import { CertificateProgramTestimonialSource } from '@mc/api'
import { LinkedInTestimonialsSection } from 'pages/certificates/components/MarketingCertPage'
import type { Testimonial } from 'pages/certificates/components/MarketingCertPage/LinkedInTestimonialsSection/types'
import type { CohortContent, CohortTestimonial } from '../types'

export const toLinkedInTestimonials = (
  testimonials: CohortTestimonial[],
): Testimonial[] =>
  testimonials.map(({ name, role, quote, linkedInUrl, avatarUrl }) => ({
    source: CertificateProgramTestimonialSource.LINKEDIN,
    customer: { name, title: role },
    body: quote,
    sourceUrl: linkedInUrl,
    avatarUrl,
  }))

export const CohortTestimonials = ({
  testimonials,
}: {
  testimonials: CohortContent['testimonials']
}) => (
  <LinkedInTestimonialsSection
    testimonials={toLinkedInTestimonials(testimonials.items)}
    title={testimonials.headline}
  />
)
